import { Component, input, output } from '@angular/core';

import { CamAddEventRequest } from '@camelot/calendar';
import { AbstractPanelFormLayout, PanelFormLayoutComponent } from '@camelot/core';
import { FilterHelper, Menu, NavigationComponent } from '@camelot/menu';

import { CreateNoteFormComponent } from '../form/create-note/create-note.component';
import { CreateUnavailabilityFormComponent } from '../form/create-unavailability/create-unavailability.component';
import { EventFormComponent, PlanningVisitFormService } from '../form/create-visit/event.component';

export enum ECalendarMenuKey {
  visits = 'visits',
  unavailabilities = 'unavailabilities',
  notes = 'notes',
}

@Component({
  selector: 'cam-create-event-selection',
  imports: [
    NavigationComponent,
    EventFormComponent,
    CreateNoteFormComponent,
    CreateUnavailabilityFormComponent,
    PanelFormLayoutComponent,
  ],
  templateUrl: './create-event-selection.component.html',
  styleUrl: './create-event-selection.component.scss',
})
export class CamCreateEventSelectionComponent extends AbstractPanelFormLayout {
  data = input<CamAddEventRequest>();

  formService = input.required<PlanningVisitFormService>();

  askClose = output<null>();

  public readonly ECalendarMenuKey = ECalendarMenuKey;

  public filterHelper = new FilterHelper([
    { label: 'planning.event-type.menu.' + ECalendarMenuKey.visits, defaultOpen: true, order: 1 },
    { label: 'planning.event-type.menu.' + ECalendarMenuKey.notes, defaultOpen: false, order: 2 },
    { label: 'planning.event-type.menu.' + ECalendarMenuKey.unavailabilities, defaultOpen: false, order: 3 },
  ]);
  public selectionCreation: Menu = this.filterHelper.getMenu();
}
